<template>
  <div class="seeding" v-if="showMedia">
    <div v-if="playerVisiable && $route.query.signalType==1" class="video">
      <ali-player ref="topicPlayer" :height="4.5" :cover="poster" :src="liveUrl" :options="options"></ali-player>
    </div>
    <div v-if="playerVisiable && $route.query.signalType==2" class="audio">
      <div class="audio-cover">
        <span class="icon" :class="{'playing':isPlaying==true}" @click.stop="playAudio"></span>
        <div class="cover"></div>
        <img :src="poster" alt="音频封面">
      </div>
      <ali-player
        style="opacity:0"
        ref="topicPlayer"
        :height="0"
        :cover="poster"
        :src="liveUrl"
        :options="options"
        @init="initPlayer"
      ></ali-player>
    </div>
    <div class="timeRange">
      <span>{{channelTitle}}</span>
      <!--<i class="timeBtn" @touchstart="getStart" @touchend="showTime"></i>-->
      <template v-if="!!showTimeList && !!intro && theme == 3">
        <mt-button
          size="small"
          type="default"
          style="float: right;border-radius: 23px;margin: 10px;color:#fff;"
          v-if="type == 1"
          @click.native="changeType(2)"
          :style="{background:colour}"
        >节目单</mt-button>
        <mt-button
          size="small"
          type="default"
          style="float: right;border-radius: 23px;margin: 10px;color:#fff;"
          v-if="type == 2"
          @click.native="changeType(1)"
          :style="{background:colour}"
        >简介</mt-button>
      </template>
    </div>
    <transition name="forward" mode="out-in">
      <div class="intro" v-if="type == 1" key="intro">{{intro}}</div>
      <div class="time-panel" v-else key="time">
        <div :class="['timeList',{'hideTimeList': !showTimeList}]">
          <div class="timeBox" ref="timeBox">
            <!-- @touchend="timeMove()" -->
            <div class="timeListMore" :style="{width: timeListWidth}">
              <span
                v-for="(item,index) in timeList"
                :key="index"
                @touchstart="getStart"
                @touchmove="moveScroll"
                @touchend="changeTime(item,index)"
                :class="{'actived':item.status==1}"
                :style="{color:item.status==1?colour:''}"
              >
                <span v-if="item.status==1" class="dot" :style="{background:colour}"></span>
                {{item.value}}
              </span>
            </div>
          </div>
        </div>
        <div class="seedingCont" ref="seedingCont" :style="{top: seedingContTp}">
          <mt-loadmore
            :autoFill="false"
            :top-method="loadTop"
            :bottom-method="loadBottom"
            :distanceIndex="3"
            :bottomAllLoaded="bottomAll"
            @top-status-change="handleTopChange"
            @bottom-status-change="handleBottomChange"
            ref="loadmore"
          >
            <div class="timeVideo">
              <div
                v-for="(item,index) in videoItems"
                @touchstart="getStart"
                @touchend="chooseVideo(index)"
                :key="index"
                :class="['videoItem', {'actived': item.status==1,'notPlay': item.status==2,'selected':videoIndex == index && currentTime==timeIndex}]"
                :style="{borderColor:videoIndex == index && currentTime==timeIndex?colour:''}"
              >
                <div class="itemInfo">
                  <span class="time">{{item.time}}</span>
                  <span class="instro" :style="{color:item.status==1?colour:''}">{{item.instro}}</span>
                </div>
                <em
                  class="status"
                  :style="{background:item.status==1?colour:''}"
                >{{item.status|playStatus}}</em>
              </div>
            </div>
            <div slot="top" class="mint-loadmore-top">
              <span v-show="topStatus !== 'loading'" :class="{ 'rotate': topStatus === 'drop' }">↓</span>
              <span v-show="topStatus === 'loading'">Loading...</span>
            </div>
            <div slot="bottom" class="mint-loadmore-bottom">
              <span
                v-show="bottomStatus !== 'loading'"
                :class="{ 'rotate': bottomStatus === 'drop' }"
              >↑</span>
              <span v-show="bottomStatus === 'loading'">Loading...</span>
            </div>
          </mt-loadmore>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ajax from "@/utils/ajax";
import AliPlayer from "../components/AliPlayer.vue";
import { Toast, MessageBox } from "mint-ui";
const jsonp = require("jsonp");

export default {
  name: "seeding",
  data() {
    return {
      type: 1,
      isPlaying: false,
      showMedia: false,
      seedingContTp: "5.78rem",
      channelTitle: "",
      colour: "",
      intro: "",
      theme: 0,
      videoIndex: 0,
      showTimeList: false,
      videoItems: [],
      timeList: [],
      liveUrl: "",
      options: {
        isLive: 1
      },
      poster: "",
      startTime: 0,
      bottomAll: false,
      topStatus: "",
      bottomStatus: "",
      currentTime: 0,
      playerVisiable: false,
      passCheck: false //是否跳过网络检查
    };
  },
  components: {
    AliPlayer
  },
  computed: {
    timeListWidth() {
      return this.timeList.length * 1.64 + "rem";
    },
    timeIndex() {
      var idx = 0;
      this.timeList.map((item, index) => {
        if (item.status === 1) {
          idx = index;
        }
      });
      return idx;
    }
  },
  beforeCreate() {
    if (typeof jingning != "undefined") {
      jingning.zbccpaper_js_close_swip_back();
    }
  },
  mounted() {
    const domain = "https://mmadmin.tmuyun.com";
    /* 测试：https://testmmadmin.tmuyun.com
          预发布：https://premmadmin.tmuyun.com
          正式：https://mmadmin.tmuyun.com */
    let that = this;
    ajax
      .get(`/playbill_${that.$route.query.id}?t=${new Date().valueOf()}`, {})
      .then(res => {
        // jsonp(
        //   `${domain}/playbill_${that.$route.query.id}?t=${new Date().valueOf()}`,{param: "callbak"},
        //   (error, res) => {
        // 时间列表
        that.timeList = [];
        for (let key in res.detail) {
          if (
            "20" + key.replace(/[\r\n]/g, "") ===
            `${new Date().getFullYear()}/${new Date().getMonth() +
              1}/${new Date().getDate()}`
          ) {
            that.timeList.push({
              value: key,
              status: 1
            });
          } else {
            that.timeList.push({
              value: key,
              status: 0
            });
          }
        }
        if (
          that.timeList.every(item => {
            return item.status === 0;
          })
        ) {
          that.timeList[0].status = 1; // 默认显示第一个时间段
        }
        // 节目列表
        that.timeList.map((item, index) => {
          if (item.status === 1) {
            that.currentTime = index;
            if (that.timeList.length > 4 && index >= 4) {
              setTimeout(() => {
                that.$refs.timeBox.scrollLeft = parseInt(
                  (index - 3) *
                    ((1.64 * document.documentElement.clientWidth) / 7.5)
                );
              }, 500);
            }
            that.getVideoItems(index);
          }
        });
        if (!!that.timeList.length) {
          that.showTimeList = true;
          that.seedingContTp = "7.06rem";
        }
      });
    // 节目详情
    // ajax
    //   .get(`/tvtopic${that.$route.query.id}.json?t=${new Date().valueOf()}`, {})
    //   .then(res => {
    //     // 频道名称
    //     that.channelTitle = res.channel;
    //     // 视频源
    //     that.poster = res.cover;
    //     that.liveUrl = res.liveUrl;
    //     that.colour = res.colour;
    //     that.playerVisiable = true;
    //     that.showMedia = true
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });

    jsonp(
      `${domain}/api/callback/pub/iptv/play?id=${that.$route.query.id}`,
      {
        param: "callbak"
      },
      (error, res) => {
        if (res.code == 0) {
          // 频道名称
          that.channelTitle = res.data.channel;
          // 视频源
          that.poster = res.data.cover;
          that.liveUrl = res.data.liveUrl;
          that.colour = res.data.colour;
          that.intro = res.data.intro;
          that.theme = res.data.theme;
          that.playerVisiable = true;
          that.showMedia = true;
          if (that.theme == 2) that.type = 2;

          if (!this.is_weixn() && 1 == 2) {
            setTimeout(() => {
              const dom = document.querySelector(".outter");
              dom.addEventListener(
                "click",
                event => {
                  if (!navigator.onLine) {
                    event.stopPropagation();
                    event.cancelBubble = true;
                    return Toast("请开启网络");
                  }

                  if (!this.passCheck) {
                    event.stopPropagation();
                    event.cancelBubble = true;

                    const func = () => {
                      this.passCheck = true;
                      dom.click();
                      setTimeout(() => {
                        //这里需要延时重复触发一次才能真正触发点击执行，什么原理还不清楚
                        dom.click();
                      }, 100);
                    };
                    CP.getDeviceInfo({
                      completed: res => {
                        if (!!res && res.networkType != "wifi") {
                          MessageBox.confirm(
                            "非wifi网络，是否使用流量播放"
                          ).then(action => {
                            func();
                          });
                        } else {
                          func();
                        }
                      },
                      cpIncompatible: () => {
                        func();
                      },
                      cp_incompatible: () => {
                        func();
                      }
                    });
                  }
                },
                false
              );
            }, 100);
          }
        }
      }
    );
  },
  methods: {
    is_weixn: function() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    changeType(type) {
      this.type = type;
      if (this.type == 2) {
        setTimeout(() => {
          this.$refs.seedingCont.scrollTop =
            (this.videoIndex * 1.56 * document.documentElement.clientWidth) /
            7.5;
        }, 1000);
      }
    },
    getVideoItems(idx) {
      let that = this;
      ajax
        .get(`/playbill_${that.$route.query.id}?t=${new Date().valueOf()}`, {})
        .then(res => {
          // 切换节目列表
          that.videoItems = [];
          let current = new Date().valueOf();
          res.detail[that.timeList[idx].value].map((item, indx) => {
            let arr = item.split(" ");
            var status;
            var nextItem;
            if (
              current >
              new Date(`20${that.timeList[idx].value} ${arr[0]}`).valueOf()
            ) {
              if (indx + 1 < res.detail[that.timeList[idx].value].length) {
                nextItem = res.detail[that.timeList[idx].value][indx + 1].split(
                  " "
                )[0];
                if (
                  current <
                  new Date(
                    `20${that.timeList[idx].value} ${nextItem}`
                  ).valueOf()
                ) {
                  status = 1;
                  that.videoIndex = indx;
                } else {
                  status = 0;
                }
              } else if (
                current <
                new Date(`20${that.timeList[idx].value} 23:59`).valueOf()
              ) {
                status = 1;
              } else {
                status = 0;
              }
            } else if (
              current <
              new Date(`20${that.timeList[idx].value} ${arr[0]}`).valueOf()
            ) {
              status = 2;
            } else {
              status = 0;
            }
            that.videoItems.push({
              time: arr[0],
              instro: arr[1],
              status
            });
          });
          setTimeout(() => {
            if (this.theme == 2) {
              that.$refs.seedingCont.scrollTop =
                (that.videoIndex *
                  1.56 *
                  document.documentElement.clientWidth) /
                7.5;
            }
          }, 1000);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showTime() {
      if (new Date().valueOf() - this.startTime < 300) {
        this.showTimeList = !this.showTimeList;
        if (this.showTimeList) {
          this.seedingContTp = "7.06rem";
        } else {
          this.seedingContTp = "5.78rem";
        }
      }
    },
    chooseVideo(index) {
      if (new Date().valueOf() - this.startTime < 300) {
        // this.videoIndex = index
      }
    },
    getStart() {
      this.startTime = new Date().valueOf();
    },
    moveScroll(event) {
      event.stopPropagation();
    },
    changeTime(item, index) {
      if (new Date().valueOf() - this.startTime < 300) {
        this.timeList.map(item => {
          item.status = 0;
        });
        item.status = 1;
        this.getVideoItems(index);
      } else {
        this.$refs.timeBox.scrollLeft =
          Math.round(
            this.$refs.timeBox.scrollLeft /
              ((1.64 * document.documentElement.clientWidth) / 7.5)
          ) *
          ((1.64 * document.documentElement.clientWidth) / 7.5);
      }
    },
    timeMove() {
      // this.$refs.timeBox.scrollLeft = Math.round(this.$refs.timeBox.scrollLeft/(1.64*document.documentElement.clientWidth / 7.5)) * (1.64*document.documentElement.clientWidth / 7.5)
    },
    loadTop() {
      setTimeout(() => {
        this.$refs.loadmore.onTopLoaded();
      }, 500);
    },
    loadBottom() {
      setTimeout(() => {
        this.$refs.loadmore.onBottomLoaded();
      }, 500);
    },
    handleTopChange(status) {
      this.topStatus = status;
    },
    handleBottomChange(status) {
      this.bottomStatus = status;
    },
    //播放音频
    playAudio() {
      const func = () => {
        this.passCheck = true;
        if (this.player.paused() == true) {
          this.player.play();
          this.isPlaying = true;
        } else {
          this.player.pause();
          this.isPlaying = false;
        }
      };
      if (!navigator.onLine) {
        return Toast("请开启网络");
      }
      if (!this.passCheck && !this.is_weixn() && 1==2) {
        CP.getDeviceInfo({
          completed: res => {
            if (!!res && res.networkType != "wifi") {
              MessageBox.confirm("非wifi网络，是否使用流量播放").then(
                action => {
                  func();
                }
              );
            } else {
              func();
            }
          },
          cpIncompatible: () => {
            func();
          },
          cp_incompatible: error => {
            func();
          }
        });
      } else {
        func();
      }
    },
    //播放器初始化，获取播放器对象
    initPlayer(player) {
      if (!this.player) {
        this.player = player;
      }
    }
  },
  filters: {
    playStatus(val) {
      switch (val) {
        case 0:
          return "结束";
          break;
        case 1:
          return "直播";
          break;
        case 2:
          return "未播";
          break;
        default:
          return;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.seeding {
  background: #f4f4f4;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .video {
    height: 4.5rem;
    background: #111;
    position: relative;
    // .video-player{
    //   width:100%;height:100%;
    // }
    // .video-js{
    //   width:100%;height:100%;
    // }
    // video{
    //   width:100%;height:100%;
    // }
    // &.audio .poster{
    //   position:absolute;top:0;left:0;width:100%;height:100%;z-index:2;
    // }
    // &.audio .vjs-big-play-centered .vjs-big-play-button{
    //   z-index:3;
    // }
    // &.audio .vjs-seeking .vjs-loading-spinner, &.audio .vjs-waiting .vjs-loading-spinner{
    //   z-index:3;
    // }
    // &.audio .video-js .vjs-control-bar{
    //   opacity:1 !important;visibility: visible !important;z-index:3 !important;display:flex !important;
    // }
    // .video-js .vjs-subs-caps-button{
    //   display:none;
    // }
  }
  .timeRange {
    height: auto;
    background: #fff;
    overflow: hidden;
    position: relative;
    z-index: 98;
    & > span {
      color: #424242;
      font: 700 0.36rem/1.28rem "Microsoft Yahei";
      float: left;
      padding: 0 0.3rem;
    }
    .timeBtn {
      float: right;
      width: 0.75rem;
      height: 1.28rem;
      margin-right: 0.3rem;
      background: url(../assets/calendar.png) no-repeat center center;
      background-size: 0.4rem;
    }
    .hideTimeList {
      height: 0;
    }
  }
  .timeList {
    background: #fff;
    float: left;
    width: 100%;
    height: 1.28rem;
    background: #fff;
    box-sizing: border-box;
    transform-origin: top center;
    transform: scaleY(1);
    transition: all 0.5s;
    overflow: hidden;
    position: relative;
    z-index: 99;
    .timeBox {
      width: 7.06rem;
      height: 1.28rem;
      overflow: auto;
      margin: 0 auto;
    }
    .timeListMore {
      min-width: 6.56rem;
      height: 1.28rem;
      transition: all 0.5s;
    }
    span {
      color: #515961;
      font: normal 0.34rem/1.28rem "Microsoft Yahei";
      float: left;
      width: 1.64rem;
      text-align: center;
      user-select: none;
      -webkit-user-select: none;
    }
    span.dot {
      position: absolute;
      bottom: 0.2rem;
      left: 50%;
      width: 0.12rem;
      height: 0.12rem;
      margin-left: -0.06rem;
      border-radius: 0.06rem;
      content: "";
    }
    span.actived {
      color: #ff2127;
      position: relative;
      // &:before {
      //   position: absolute;
      //   bottom: 0.2rem;
      //   left: 50%;
      //   width: 0.12rem;
      //   height: 0.12rem;
      //   margin-left: -0.06rem;
      //   background: #ff2127;
      //   border-radius: 0.06rem;
      //   content: "";
      // }
    }
  }
  .timeVideo {
    background: #fff;
    padding: 0 0.3rem;
    overflow: hidden;
    .videoItem {
      border: solid 0.04rem transparent;
      box-sizing: border-box;
      margin: 0.2rem 0;
      padding: 0 0.2rem;
      height: 1.36rem;
      .itemInfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        padding-top: 0.4rem;
      }
      .time {
        color: #8e96a9;
        font: normal 0.28rem/0.48rem "Microsoft Yahei";
        width: 0.8rem;
        text-align: center;
        margin-right: 0.2rem;
      }
      .instro {
        color: #8e96a9;
        font: normal 0.34rem/0.48rem "Microsoft Yahei";
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 0.48rem;
        flex: 1;
      }
      .status {
        color: #8e96a9;
        font: normal 0.28rem/0.4rem "Microsoft Yahei";
        text-align: center;
        display: block;
        width: 0.8rem;
        height: 0.4rem;
        background: #efefef;
      }
      &.actived {
        .instro {
          color: #ff2127;
        }
        .status {
          color: #fff;
          background: #ff2127;
        }
      }
      &.notPlay {
        .status {
          color: #ffffff;
          background: #515961;
        }
      }
    }
  }
  .seedingCont {
    transition: all 0.5s;
    position: fixed;
    bottom: 0;
    top: 6.38rem;
    width: 100%;
    left: 0;
    overflow: auto;
  }
  .mint-loadmore {
    border-top: solid 0.3rem #f4f4f4;
  }
  .mint-loadmore-top {
    color: #ccc;
    font-size: 0.4rem;
  }
  .mint-loadmore-bottom {
    color: #ccc;
    font-size: 0.4rem;
  }
  .audio {
    line-height: 0;
    height: 4.5rem;
    .audio-cover {
      position: relative;
      height: 100%;
      .cover {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        z-index: 9;
      }
      .icon {
        display: block;
        position: absolute;
        height: 0.9rem;
        width: 0.9rem;
        background: url(../assets/play.png) no-repeat;
        background-size: 100% auto;
        top: 50%;
        left: 50%;
        margin-top: -0.45rem;
        margin-left: -0.45rem;
        z-index: 10;
        cursor: pointer;
        outline: none;
        &.playing {
          background-image: url(/static/wave.gif);
        }
      }
      img {
        width: auto;
        height: 100%;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .intro {
    padding: 20px;
    word-break: break-all;
    white-space: pre-wrap;
    font-size: 0.32rem;
    box-sizing: border-box;
    transition: opacity 0.5s, transform 0.5s;
    position: fixed;
    bottom: 0;
    top: 5.74rem;
    width: 100%;
    left: 0;
    overflow: auto;
  }
  .time-panel {
    transition: opacity 0.5s, transform 0.5s;
  }
}

.forward-enter,
.back-leave-active {
  opacity: 0.5;
  transform: translateX(100%);
}
.forward-leave-active,
.back-enter {
  opacity: 0.5;
  transform: translateX(-100%);
}
</style>



// WEBPACK FOOTER //
// src/view/seeding.vue